import { render, staticRenderFns } from "./MasterIuran.vue?vue&type=template&id=1985afb7"
import script from "./MasterIuran.vue?vue&type=script&lang=js"
export * from "./MasterIuran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports